import { render } from "./FormStepsNavbar.vue?vue&type=template&id=0dc37956"
import script from "./FormStepsNavbar.vue?vue&type=script&lang=js"
export * from "./FormStepsNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/filip/coding/shean/reklamace/reklamace-fe-slovakova/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__